
const config = {};

// API Endpoints base URL
config.BASEURL = 'https://opintokamupeli.fi/';
config.SOCKETURL = `wss://opintokamupeli.fi/gameconnection/`;

module.exports = config;
